import { styled } from '@mui/material';

import { ReactNode } from 'react';

import { I18nResources, useI18n } from '@app-velocity/i18n';
import { Card, Page, Typography } from '@app-velocity/ui';

export type SettingsCardProps = {
  title: I18nResources;
  description: I18nResources;
  children: ReactNode;
};

const StyledSettingsCard = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
}));

const CardContent = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

const CardHeader = styled('header')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const SettingsCard = ({
  title,
  description,
  children,
}: SettingsCardProps) => {
  const { t } = useI18n();

  return (
    <StyledSettingsCard>
      <Page.Subheader title={t(title)} />
      <Card>
        <CardContent>
          <CardHeader>
            <Typography>{t(description)}</Typography>
          </CardHeader>
          {children}
        </CardContent>
      </Card>
    </StyledSettingsCard>
  );
};
